import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: "c1",
    categoryName: "Music",
    categoryImage:
      "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
  },
  {
    _id: "c2",
    categoryName: "Thriller",
    categoryImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThZDbdzTVMJU6xVQfHuH3ayLagohrNyvj-2w&usqp=CAU",
  },
  {
    _id: "c3",
    categoryName: "Drama",
    categoryImage:
      "https://www.okeasylife.com/wp-content/uploads/2018/12/Bollywood-Comedy-Movies.jpg",
  },
  {
    _id: "c4",
    categoryName: "Cooking",
    categoryImage:
      "https://images.unsplash.com/photo-1605522469906-3fe226b356bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1472&q=80",
  },
  {
    _id: "c5",
    categoryName: "Love",
    categoryImage:
      "https://miro.medium.com/max/1200/1*OEnS6-DEn56szCwdOs2mrA.jpeg",
  },
];
